var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40026 3.59704L6.16943 1.28154C6.27798 1.14366 6.4062 1.03999 6.55409 0.970544C6.70198 0.900989 6.85626 0.866211 7.01693 0.866211C7.17759 0.866211 7.32909 0.900989 7.47143 0.970544C7.61376 1.03999 7.7392 1.14366 7.84776 1.28154L9.61693 3.59704L12.3399 4.49438C12.5699 4.57904 12.7475 4.71166 12.8726 4.89221C12.9978 5.07288 13.0604 5.27588 13.0604 5.50121C13.0604 5.60954 13.0458 5.71471 13.0164 5.81671C12.9871 5.91871 12.9381 6.01854 12.8694 6.11621L11.1079 8.52388L11.1746 11.1342C11.1746 11.4408 11.07 11.7005 10.8608 11.9134C10.6516 12.1264 10.4024 12.2329 10.1131 12.2329C10.1036 12.2329 10.0088 12.2183 9.82843 12.1892L7.00026 11.3854L4.17209 12.1892C4.11654 12.2114 4.06754 12.2243 4.02509 12.2277C3.98265 12.2312 3.93676 12.2329 3.88743 12.2329C3.59509 12.2329 3.34232 12.1264 3.12909 11.9134C2.91587 11.7005 2.81482 11.4408 2.82593 11.1342L2.89259 8.52388L1.12459 6.11621C1.05593 6.0181 1.00693 5.9206 0.977594 5.82371C0.94826 5.72671 0.933594 5.62421 0.933594 5.51621C0.933594 5.28699 0.998483 5.07816 1.12826 4.88971C1.25804 4.70127 1.44315 4.56738 1.68359 4.48804L4.40026 3.59704Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.d320ed4aa0e06ae7c0d375cf1afd7464.svg";
export { ForwardRef as ReactComponent };